// extracted by mini-css-extract-plugin
export default {"-large":"VO4xR3IH1r73ySDdbN1F","fbLogoContainer":"zY4moJzWZw4cBScJBqtg","text":"XPJy0mj6JWJcVqLOYB8o"};